/*@flow*/
import { useRef, useEffect } from 'react';
import useStoreState from 'lib/useStoreState';
import { set } from 'ops';
import history from 'lib/history';
import hash from 'lib/hash';
import * as I from 'immutable';

export default function useQueryTracker() {
  const isPristine = useRef(true);
  const { s } = useStoreState({ s: '$query' });

  useEffect(() => {
    if (!isPristine.current) return;
    const browserQuery = history.getQuery();
    set('$query', I.fromJS(browserQuery));
    set('$queryInitialized', true);
    isPristine.current = false;
  }, []);

  useEffect(() => {
    if (isPristine.current) return;
    history.updateQuery(s.toJS());
  }, [hash(s)]);
}
